<template>
  <div class="border-2 border-gray-800">
    
    <AssetHeader 
      :index="index" 
      :updateValue="updateValue"
      :assetId="asset.id"
      :assetType="parseInt(asset.type)"
      :deleteAsset="deleteAsset"></AssetHeader>

    <div class="flex flex-wrap -mx-2 p-4">
      <div class="w-full lg:w-1/3 px-2">          
        <div class="">
          <InputText 
            label="Address"
            propertyKey="string1"
            objectType="asset"
            objectSubType="investmentProperty"
            :index="index"
            :objectId="asset.id"
            :value="asset.string1"
            :updateValue="updateValue"
            :required="true" />

          <div class="mt-1 text-right" v-if="asset.string1 != null && asset.string1.length > 0">
            <a href="#" class="text-gray-700 hover:underline" @click.prevent="$modal.show('map-modal', { 
              address : asset.string1
            })">Show this address on map</a>
          </div>
        </div>

        <div class="mt-6 flex flex-wrap">
          <div class="w-1/2">
            <InputDollarValue 
              ref="inputFamilyAmount"
              label="Rental income"
              propertyKey="string2"
              objectType="asset"
              objectSubType="investmentProperty"
              :index="index"
              :objectId="asset.id"
              :value="asset.string2"
              :updateValue="updateValue"
              :required="true"/>
          </div>

          <div class="w-1/2 pl-3" style="margin-top:28px;">
            <select 
              :value="asset.period"
              v-on:change="updateValue({
                objectType: 'asset',
                objectId  : asset.id,
                index     : index,
                key       : 'period',
                value     : $event.target.value
              })"
              class="select-standard">
              <option value="-1" disabled="">Select an option...</option>
              <option value="0">Per Week</option>
              <option value="1">Per Month</option>
              <option value="2">Per Annum</option>
            </select>
          </div>
        </div>

        <div class="mt-6">
          <InputDatePickerReadOnly 
            label="Purchase date"
            propertyKey="purchased_at"
            objectType="asset"
            :maxDate="today"
            :index="index"
            :objectId="asset.id"
            :value="asset.purchased_at"
            :updateValue="updateValue" />
        </div>
      </div>

      <div class="w-full lg:w-1/3 px-2 mt-6 lg:mt-0">
        <InputDollarValue 
          propertyKey="value"
          objectType="asset"
          label="Value"
          objectSubType="savings"
          :required="true"
          :objectId="asset.id"
          :index="index"
          :value="asset.value"
          :updateValue="updateValue"/>
      </div>

      <div class="w-full lg:w-1/3 px-2 mt-6 lg:mt-0">
        <Ownership :asset="asset" />
      </div>
    </div>
  </div>
</template>

<script>
  import AssetHeader              from '../AssetHeader'
  import InputText                from '@/shared/components/form/InputText'
  import InputDollarValue         from '@/shared/components/form/InputDollarValue'
  import InputDatePickerReadOnly  from '@/shared/components/form/InputDatePickerReadOnly'
  import Ownership                from '@/shared/components/Ownership'

  export default {

    components: {
      AssetHeader,
      InputText,
      InputDollarValue,
      InputDatePickerReadOnly,
      Ownership
    },

    props : {
      asset : {
        type     : Object,
        required : true
      },

      index : {
        type : Number,
        required : false
      },

      updateValue : {
        type     : Function,
        required : false
      },

      deleteAsset : {
        type    : Function,
        required: false
      },
    }
  }
</script>